export default __webpack_public_path__ + "static/media/washing-machine.49c3cc6b.svg";